const secParam = new URLSearchParams(window.location.search).get('sec');


function scrollToEl(el) {
  const num = window.innerWidth > 992 ? 100 : 130;
  const y = el.getBoundingClientRect().top + window.scrollY - num;
  window.scroll({top: y, behavior: 'smooth'});
}

function scrollToContentByUrl(hashKey) {
  const scrolledElement = document.querySelector('[data-name="' + hashKey + '"]');
  if (scrolledElement) {
    const scrolledElementHash = scrolledElement.getAttribute('data-name');
    if (hashKey === scrolledElementHash) {
      scrollToEl(scrolledElement);
    }
  }
}

function scrollToContentByClick(link) {

  link.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const hashKey = e.target.href.split('#')[1];
    const scrolledElement = document.querySelector('[data-name="' + hashKey + '"]');
    const scrolledElementHash = scrolledElement.getAttribute('data-name');

    if (e.target.href.split('#')[1] === scrolledElementHash) {
      scrollToEl(scrolledElement);
    }
  });
}

const scrollToHashKeywordFaqAccordion = () => {
  const faqSliderLinks = document.querySelectorAll('.faq-accordion__slider-wrapper li a');
  for (var i = 0; i < faqSliderLinks.length; i++) {
    const link = faqSliderLinks[i];
    scrollToContentByClick(link);
  }
};

scrollToHashKeywordFaqAccordion();

document.addEventListener("DOMContentLoaded", (event) => {
  if (secParam) {
    setTimeout(() => {
      // Wait for swiper init / .js_faq_items_slider_v1
      scrollToContentByUrl(secParam);
    }, 500);
  }
});






